export const states = ['REQUEST', 'DONE', 'ERROR']

export const stateLabels = {
  REQUEST: 'Oczekuje',
  DONE: 'Zakończono',
  ERROR: 'Błąd',
}

export const stateImages = {
  REQUEST: require('../../images/clockIcon.svg'),
  GENERATING: require('../../images/clockIcon.svg'),
  DONE: require('../../images/checkmarkIcon.svg'),
  ERROR: require('../../images/alertIcon.svg'), // TODO FIND APPRIOPRATE ICON
}
